"use client";

import { useTranslations } from "next-intl";

import { type TourConfig } from "~/lib/tours";
import { useCurrencyFormatter } from "~/lib/use-currency";

import { type TourFromPage } from "../page";

export function Header({
  tour,
  amount,
  pricedPerPassenger,
}: {
  amount?: number;
  tour: TourFromPage;
} & Pick<TourConfig, "pricedPerPassenger">) {
  const formatCurrency = useCurrencyFormatter();
  const t = useTranslations("TourDetails");
  return (
    <div className="flex items-baseline gap-1">
      <div className="font-display text-2xl font-semibold">
        {t("fromAmount", {
          currencyAmount: formatCurrency(amount ?? tour.fromPrice),
        })}
      </div>
      <div className="font-display font-light text-neutral-500">
        {pricedPerPassenger ? t("perPerson") : t("perGroup")}
      </div>
    </div>
  );
}
